var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ps-product__info"},[_c('module-product-info',{attrs:{"product":_vm.product}}),_vm._v(" "),_c('module-product-detail-desc',{attrs:{"product":_vm.product}}),_vm._v(" "),_c('module-product-shopping',{attrs:{"product":_vm.product}}),_vm._v(" "),_c('color-memory')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }